import { FunctionParameters } from '@osos/shared/api';
import { LocalizedValueModel } from '../localized-value.model';

export class CustomFunctionPresenterModel {
  id?: string;
  name: LocalizedValueModel;
  normalizedName: string;

  parameters: FunctionParameters[];
}
